import React, { useState, useMemo, useContext, useEffect } from "react";

const BASE_URL = 'https://gov-api.vostokfamily.ru/'
const SHOP_ID = 1

const error = (message) => {
	return {
		status: false,
		message: message
	}
}

const sendPostRequest = async (path, data = {}, headersData = {}) => {
	const myHeaders = new Headers();

	for (let key in headersData) {
		myHeaders.append(key, headersData[key])
	}

	data.shop_id = SHOP_ID

	const response = await fetch(
		BASE_URL + path,
		{
			credentials: 'include',
			method: "POST",
			headers: myHeaders,
			body: JSON.stringify(data)
		},
	);
	const responseJSON = await response.json();

	if (responseJSON.status.result == 'ERROR') {
		const message = responseJSON.status.message ?? 'Произошла ошибка при выполнении запроса!';
		return error(message)
	}

	return {
		status: true,
		data: responseJSON.data,
		message: responseJSON.status.message
	}
}

export async function fetchScreenUrl(params) {
	try {
		return await sendPostRequest('user/ad/ad-screen', params)
	} catch (e) {
		console.warn(e);
	}
}

function Screen() {
    const [url, setUrl] = useState(false)
    const [type, setType] = useState('image')
    const [rotationClass, setRotationClass] = useState('normal')

    const classes = [
        'normal', 'rotate90', 'rotate180', 'rotate270'
    ]

    const rotateRight = () => {
        return;
        for (let i = 0; i < classes.length; i++) {
            if (rotationClass == classes[i]) {
                if (typeof classes[i + 1] !== "undefined") {
                    setRotationClass(classes[i + 1])
                } else {
                    setRotationClass(classes[0])
                }
            }
        }
    }

    const getUrl = async () =>
    {
        const queryParams = new URLSearchParams(window.location.search)
        const screen = queryParams.get('screen')

        if (screen && screen.length) {
            const result = await fetchScreenUrl({screen_id: screen})
            if (result) {
                setType(result.data.type)
                setUrl(result.data.source)
            }
        }

        setTimeout(() => {
            getUrl()
        }, 900000)
    }

    useEffect(() => {
        getUrl()
    }, [])

    

    if (!url) {
        return null
    }

    if (type == 'image') {
        return (
            <div className={ "screen" }>
                <div className={ rotationClass } style={{background: 'url(' + url + ')'}} onClick={ () => rotateRight() }></div>
            </div>
        );
    }

    return (
        <div className={ "screen" }>
            <video className={ rotationClass } autoPlay loop muted>
                { url ? <source src={ url } type="video/mp4" /> : null}
            </video>
        </div>
    );
}

export default Screen;
